// Indexing policy (proposed release). Pages listed here render normally but emit "noindex,follow"
// and are excluded from the sitemap until they have genuinely unique, useful content.
// Register with reasons: /app/memory/seo/review/F_noindex_register.md
import { PRODUCT_MARKET_SLUGS, STEEL_SUB_SLUGS, STEEL_MARKET_PATHS, STEEL_GUIDE_SLUGS, PET_SUB_SLUGS, PET_MARKET_PATHS } from "./routeIndex";

// Programme pages awaiting owner approval (noindex + out of sitemap). Owner approved all 41 on 2026-10-26.
export const STEEL_REVIEW = [];
export const STEEL_APPROVED = [...STEEL_SUB_SLUGS.map((s) => "/" + s), ...STEEL_MARKET_PATHS,
  ...STEEL_GUIDE_SLUGS.map((g) => "/insights/" + g),
  "/pet-products-sourcing-india", ...PET_SUB_SLUGS.map((s) => "/" + s), ...PET_MARKET_PATHS];

const THIN_MARKETS = ["france", "netherlands", "sweden", "denmark", "italy", "spain", "finland",
  "australia", "south-africa", "middle-east"].map((m) => `/${m}-india-sourcing`);

const COUNTRY_BY_CATEGORY = PRODUCT_MARKET_SLUGS.map((s) => "/" + s);

// Near-duplicate intent of /sourcing-company-india; merge candidate (no server-side 301 available).
const DUPLICATE_INTENT = ["/india-sourcing-company"];

export const NOINDEX_TEMP = new Set([...THIN_MARKETS, ...COUNTRY_BY_CATEGORY, ...DUPLICATE_INTENT, ...STEEL_REVIEW]);

// Legacy /sourcing/:country/:category combo pages (thin, unlinked) are noindexed by prefix.
export const isTempNoindex = (path) => NOINDEX_TEMP.has(path) || path.startsWith("/sourcing/");
